import React from 'react';
import { connect } from 'react-redux';
import { Grid, CircularProgress } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import BackgroundStockImagesCard from './BackgroundStockImagesCard';
import BackgroundStockImagesLoadMoreCard from './BackgroundStockImagesLoadMoreCard';
import EmptyGalleryLabel from '../../../common/EmptyGalleryLabel';

const styles = theme => ({
    galleryProgress: {
        margin: theme.spacing(4, 0, 4, 0) 
    },
    imagesContentWrapper: {
        padding: `${theme.spacing(2)} 0`
    }
});

const galleryCardWidth = 146;
const galleryCardHeight = 146;

const BackgroundStockImagesContainer = (props) => {
    const { classes, backgroundStockImagesInitializing, backgroundStockImages, backgroundStockImagesAllCount } = props;

    return (
        <Grid className={classes.imagesContentWrapper}>
            <Grid
                container
                direction='row'
                justifyContent='center'
                alignItems='flex-start'
            >
                {backgroundStockImagesInitializing ?
                    <Grid className={classes.galleryProgress}>
                        <CircularProgress />
                    </Grid>
                :
                    backgroundStockImages && backgroundStockImages.length
                    ?
                        <>
                            {backgroundStockImages.map((image, index) => 
                                <BackgroundStockImagesCard
                                    key={image.id}
                                    index={index}
                                    galleryCardWidth={galleryCardWidth}
                                    galleryCardHeight={galleryCardHeight}
                                />
                            )}

                            {backgroundStockImages.length < backgroundStockImagesAllCount && 
                                <BackgroundStockImagesLoadMoreCard
                                    galleryCardWidth={galleryCardWidth}
                                    galleryCardHeight={galleryCardHeight}
                                />
                            }
                        </>
                    :
                    <EmptyGalleryLabel />
                }
            </Grid>
        </Grid>
    );
};

const mapStateToProps = (state) => {
    const { 
        backgroundStockImagesInitializing,
        backgroundStockImages,
        backgroundStockImagesAllCount,
    } = state.mediaPicker;

    return { 
        backgroundStockImagesInitializing,
        backgroundStockImages,
        backgroundStockImagesAllCount,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(BackgroundStockImagesContainer, styles));